import {
  BondProduct,
  BondProductTypeEnum,
} from 'global/Securities/types/api/bond';

export const BOND_PRODUCT_MOCK: BondProduct = {
  icon_url: undefined,
  id: 'FR0081',
  min_order: '1',
  name: 'Obligasi Fixed Rate Pemerintah',
  type: BondProductTypeEnum.FR,
};

export const BOND_ASSET_MOCK = [
  {
    investmentModal: 4_000_000,
    orderId: 'ABC120',
    orderDate: new Date(),
    product: BOND_PRODUCT_MOCK,
    totalUnits: 4,
  },
  {
    investmentModal: 3_000_000,
    orderId: 'ABC121',
    orderDate: new Date(),
    product: BOND_PRODUCT_MOCK,
    totalUnits: 1,
  },
  {
    investmentModal: 2_000_000,
    orderId: 'ABC122',
    orderDate: new Date(),
    product: BOND_PRODUCT_MOCK,
    totalUnits: 1,
  },
];
